import { getHotelCenterShared } from '@bingads-webui-campaign/hotel-center-shared';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { SubAccount, HotelGroup, Multiplier, Hotel, PercentageBid, FixedBid, PayPerStayBid } from '@bingads-webui/hotel-odata-schemas';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center-shared');
const pageContext = globalContext.require('PageContext');
const state = globalContext.require('component/state/index');
const dateFilterPreferences = globalContext.require('component/bingads-grid/service/date-filter-preferences');
const segmentationPreferences = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const preferencesService = globalContext.require('component/preference/service/index');
const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const edm = globalContext.requireDefault('campaignui/feature/hotel-center-edm/index');
const config = globalContext.require('component/config/index');

export const {
  HotelGroupInformationView,
  dateFilterPlugin,
  fetchPreferenceConfig,
  instrumentation,
  toolbarTemplate,
  BidMultipliersView,
  BidStrategyView,
  HotelModel,
  HotelGroupModel,
  EditPanelView,
  SubAccountModel,
  BidCapView,
  lightDismissible,
} = getHotelCenterShared({
  i18n,
  pageContext,
  state,
  dateFilterPreferences,
  preferencesService,
  segmentationPreferences,
  config,
  multiplierSchema: Multiplier,
  fixedBidSchema: FixedBid,
  percentageBidSchema: PercentageBid,
  payPerStayBidSchema: PayPerStayBid,
  hotelSchema: Hotel,
  jsdata,
  edm,
  hotelGroupSchema: HotelGroup,
  subAccountSchema: SubAccount,
});
